

import {
    ITextBetLineNumberConfig,
    TextBetLineNumber
} from "@nolimitcity/slot-game/bin/game/betline/number/TextBetLineNumber";

export class HarlequinTextBetLineNumber extends TextBetLineNumber {

    constructor(index: number, config: ITextBetLineNumberConfig) {
        super(index, config);
    }

    protected draw(config: ITextBetLineNumberConfig): void {

    }

    protected showMouseOver(): void {}
    protected showMouseOut(): void {}
    protected showWin(): void {}
    protected showNormal(): void {}

}